import React from 'react';

import { isEmptyCollection, useArchivedEventState, useTranslation } from '@atlas/core';
import { Loader } from '@atlas/ui';

import DetailsEvent from '../Details/DetailsEvent';

const Details = ({ isIframe = false }) => {
  const t = useTranslation();
  const event = useArchivedEventState();

  if ((!event.initialized && event.loading) || isEmptyCollection(t)) {
    return (
      <div className="details-event-loader">
        <Loader className="absolute" />
      </div>
    );
  }

  return <DetailsEvent isIframe={isIframe} isResults />;
};

export default Details;
